/**
 * Allow-list URL sanitizer for operator-authored links rendered as <a href>
 * on the public surface (ticker events, venue maps links).
 *
 * Operator content is trusted-ish, but a compromised operator account must
 * not be able to plant `javascript:` / `data:` URLs that execute in every
 * visitor's browser. Anything that isn't plain web navigation is dropped —
 * callers render plain text instead of a link.
 */

const SAFE_PROTOCOLS = new Set(["http:", "https:", "mailto:", "tel:"]);

export function safeHref(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  try {
    // Base resolves protocol-relative and path-only values so they parse
    // instead of throwing; their resolved protocol is then http(s) and safe.
    const parsed = new URL(url, window.location.origin);
    return SAFE_PROTOCOLS.has(parsed.protocol) ? url : undefined;
  } catch {
    return undefined;
  }
}
